import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingService } from './loading.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/core/material/material.module';
import { GoogleMapsModule } from '@angular/google-maps';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule, MaterialModule, GoogleMapsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  private loadingService = inject(LoadingService);

  loading = toSignal(this.loadingService.isLoading, { requireSync: true });
}
